import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

export const AbsFunction: HelperFunction = {
	tokenName: 'ABS',
	nodeType: functionNodeTypes.Abs,
	evaluate(node, evaluateExpr) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('Abs function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (result.value === undefined || Array.isArray(result.value)) return ok(null)
		const value = result.value
		if (value === null || value === undefined || value === '') return ok(null)
		const num = Number(value)
		return ok(isNaN(num) ? null : Math.abs(num))
	}
}
